var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"radio-wrapper"},[_c('RadioListItem',{attrs:{"list":_vm.list,"selected":_vm.selected,"mobile":_vm.mobile},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }